// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1NJWe","filled":"Button_filled__10pqp","link":"Button_link__xgDIi"};